import { render, staticRenderFns } from "./AboutGlobal.vue?vue&type=template&id=6b9c9dbe&scoped=true&"
import script from "./AboutGlobal.vue?vue&type=script&lang=js&"
export * from "./AboutGlobal.vue?vue&type=script&lang=js&"
import style0 from "./AboutGlobal.vue?vue&type=style&index=0&id=6b9c9dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c9dbe",
  null
  
)

export default component.exports